import Joi from 'joi';
import { errorsHandler } from './errorsHandler';
export const SETTINGS_CONFIG_VALIDATOR = () => {
  return Joi.object({
    colors: {
      primaryColor: Joi.string().required(),
      secondaryColor: Joi.string().required(),
      backgroundColor: Joi.string().required(),
      textColor: Joi.string().required(),
      textColorButton: Joi.string().required()
    },
    fonts: Joi.object({
      primaryFont: Joi.string().required(),
      secondaryFont: Joi.string().required()
    }),
    design: Joi.object({
      buttonType: Joi.string().required()
    })
  });
};
export const HOME_PAGE_CONFIG_VALIDATOR = () => {
  return Joi.object({
    backgroundImage: Joi.string().required().error(errors => errorsHandler(errors, 'backgroundImage', 'Immagine principale')),
    bigLogo: Joi.string().required().error(errors => errorsHandler(errors, 'bigLogo', 'Logo centrale')),
    smallLogoNavbar: Joi.string().required().error(errors => errorsHandler(errors, 'smallLogoNavbar', 'Logo navbar')),
    smallLogo: Joi.string().allow('').error(errors => errorsHandler(errors, 'smallLogo', 'Pittogramma background')),
    homePage: Joi.object({
      boxes: Joi.array().items({
        component: Joi.string().required(),
        navigation: Joi.string().invalid('/').required().error(errors => errorsHandler(errors, 'navigation_{INDEX_0}', 'Navigazione tile {NAME}', [1], (component, indexes) => {
          let index = indexes[0];
          return component.homePage.boxes[index].title !== '' ? component.homePage.boxes[index].title : index + 1;
        })),
        image: Joi.string().required().error(errors => errorsHandler(errors, 'tile_image_{INDEX_0}', 'Immagine card tile {NAME}', [1], (component, indexes) => {
          let index = indexes[0];
          return component.homePage.boxes[index].title !== '' ? component.homePage.boxes[index].title : index + 1;
        })),
        icon: Joi.string().required().error(errors => errorsHandler(errors, 'tile_icon_{INDEX_0}', 'Icona card tile {NAME}', [1], (component, indexes) => {
          let index = indexes[0];
          return component.homePage.boxes[index].title !== '' ? component.homePage.boxes[index].title : index + 1;
        })),
        title: Joi.string().required().error(errors => errorsHandler(errors, 'tile_title_{INDEX_0}', 'Titolo tile {NAME}', [1], (component, indexes) => {
          let index = indexes[0];
          return component.homePage.boxes[index].title !== '' ? component.homePage.boxes[index].title : index + 1;
        })),
        dimension: Joi.number(),
        flagComingSoon: Joi.boolean().required().error(errors => errorsHandler(errors, 'tile_type_{INDEX_0}', 'Tipologia tile {NAME}', [1], (component, indexes) => {
          let index = indexes[0];
          return component.homePage.boxes[index].title !== '' ? component.homePage.boxes[index].title : index + 1;
        })),
        flagExternalLink: Joi.boolean().required().error(errors => errorsHandler(errors, 'tile_type_{INDEX_0}', 'Tipologia tile {NAME}', [1], (component, indexes) => {
          let index = indexes[0];
          return component.homePage.boxes[index].title !== '' ? component.homePage.boxes[index].title : index + 1;
        })),
        index: Joi.number().required(),
        exact: Joi.boolean().required(),
        visible: Joi.boolean().required().error(errors => errorsHandler(errors, 'tile_type_{INDEX_0}', 'Tipologia tile {NAME}', [1], (component, indexes) => {
          let index = indexes[0];
          return component.homePage.boxes[index].title !== '' ? component.homePage.boxes[index].title : index + 1;
        }))
      })
    })
  }).options({
    stripUnknown: true
  });
};
export const VIRTUAL_PHOTO_CONFIG_VALIDATOR = () => {
  return Joi.object({
    componentParams: Joi.object({
      numCategories: Joi.number().required(),
      icon: Joi.string(),
      title: Joi.string(),
      categories: Joi.array().min(1).max(3).items({
        name: Joi.string().required(),
        title: Joi.string().required().error(errors => errorsHandler(errors, 'title_category_{INDEX_0}', 'Titolo categoria {NAME}', [1], (component, indexes) => {
          let index = indexes[0];
          return component.componentParams.categories[index].name !== '' ? component.componentParams.categories[index].name : index + 1;
        })),
        cover: Joi.string().required().error(errors => errorsHandler(errors, 'cover_category_{INDEX_0}', 'Cover categoria {NAME}', [1], (component, indexes) => {
          let index = indexes[0];
          return component.componentParams.categories[index].name !== '' ? component.componentParams.categories[index].name : index + 1;
        })),
        numCols: Joi.number().required(),
        numRows: Joi.number().required(),
        thumbnails: Joi.array().items({
          path: Joi.string().required(),
          imageStructure: Joi.object({
            rowStart: Joi.number().required(),
            rowEnd: Joi.number().required(),
            colStart: Joi.number().required(),
            colEnd: Joi.number().required()
          })
        }).min(1).max(20).required().error(errors => errorsHandler(errors, 'mosaico_{INDEX_0}', 'Mosaico slider categoria {NAME}', [3], (component, indexes) => {
          let index = indexes[0];
          return component.componentParams.categories[index].name !== '' ? component.componentParams.categories[index].name : index + 1;
        })),
        images: Joi.array().items(Joi.string().error(errors => errorsHandler(errors, 'img_slider_{INDEX_0}_{INDEX_1}', 'Immagine slider {INDEX_1} categoria {NAME}', [2, 0], (component, indexes) => {
          let index = indexes[0];
          return component.componentParams.categories[index].name !== '' ? component.componentParams.categories[index].name : index + 1;
        }))).min(1).max(20).required().error(errors => errorsHandler(errors, 'img_slider_{INDEX_0}', 'Immagini slider categoria {NAME}', [1], (component, indexes) => {
          let index = indexes[0];
          return component.componentParams.categories[index].name !== '' ? component.componentParams.categories[index].name : index + 1;
        })),
        allThumbs: Joi.array().items(Joi.string().error(errors => errorsHandler(errors, 'img_thumb_{INDEX_0}_{INDEX_1}', 'Immagine thumbnail {INDEX_1} categoria {NAME}', [2, 0], (component, indexes) => {
          let index = indexes[0];
          return component.componentParams.categories[index].name !== '' ? component.componentParams.categories[index].name : index + 1;
        }))),
        mosaicMapping: Joi.array().items(Joi.number())
      }).required().error(errors => errorsHandler(errors, 'categories', 'Categorie'))
    })
  }).options({
    stripUnknown: true
  });
};
export const INTERIOR_EXPERIENCE_CONFIG_VALIDATOR = () => {
  return Joi.object({
    componentParams: Joi.object({
      planimetry: Joi.string().required().error(errors => errorsHandler(errors, 'planimetry', 'Planimetria')),
      viewIcon: Joi.string(),
      viewIconActive: Joi.string(),
      icon: Joi.string().error(errors => errorsHandler(errors, 'icon', 'Icona')),
      title: Joi.string().error(errors => errorsHandler(errors, 'title', 'Titolo')),
      pinsOutside: Joi.array().items(Joi.number()).required().max(0).error(errors => errorsHandler(errors, 'pinsOutside', 'Coni non posizionati', [], null, 'alcuni coni non sono stati posizionati sulla planimetria.')),
      views: Joi.array().items({
        coords: Joi.object({
          y: Joi.number().required(),
          x: Joi.number().required(),
          rotateDegree: Joi.number().required()
        }),
        image: Joi.string().required().error(errors => errorsHandler(errors, 'img_pin_{INDEX_0}', 'Immagine puntamento cono {INDEX_0}', [1])),
        index: Joi.number().required()
      }).min(1).max(10).required().error(errors => errorsHandler(errors, 'views', 'Coni ottici'))
    })
  }).options({
    stripUnknown: true
  });
};
export const SLIDER_GALLERY_LOGO_CONFIG_VALIDATOR = () => {
  return Joi.object({
    componentParams: Joi.object({
      backgroundSize: Joi.string(),
      numImages: Joi.number(),
      galleryImages: Joi.array().items(Joi.string()).min(1).required().error(errors => errorsHandler(errors, 'galleryImages', 'Immagini')),
      index: Joi.array().items({
        num: Joi.number().required(),
        image: Joi.string().required().error(errors => errorsHandler(errors, 'index_logo_{INDEX_0}', 'Logo capitolo {INDEX_0}', [1]))
      }),
      indexPosition: Joi.string()
    })
  }).options({
    stripUnknown: true
  });
};
export const SLIDER_GALLERY_CONFIG_VALIDATOR = () => {
  return Joi.object({
    componentParams: Joi.object({
      backgroundSize: Joi.string(),
      numImages: Joi.number(),
      galleryImages: Joi.array().items(Joi.string()).min(1).required().error(errors => errorsHandler(errors, 'galleryImages', 'Immagini')),
      index: Joi.array().items({
        num: Joi.number().required(),
        name: Joi.string().required().error(errors => errorsHandler(errors, 'index_name_{INDEX_0}', 'Indice capitolo {INDEX_0}', [1]))
      }),
      indexPosition: Joi.string()
    })
  }).options({
    stripUnknown: true
  });
};
export const VIRTUAL_TOUR_CONFIG_VALIDATOR = () => {
  return Joi.object({
    componentParams: Joi.object({
      images: Joi.array().min(1).max(7).items({
        id: Joi.required(),
        img: Joi.string().required().error(errors => errorsHandler(errors, 'image_{INDEX_0}', 'Immagine {NAME}', [1], (component, indexes) => {
          let imageIndex = indexes[0];
          return component.componentParams.images[imageIndex].name !== '' ? component.componentParams.images[imageIndex].name : imageIndex + 1;
        })),
        name: Joi.string().required().error(errors => errorsHandler(errors, 'name_{INDEX_0}', 'Nome {NAME}', [1], (component, indexes) => {
          let imageIndex = indexes[0];
          return component.componentParams.images[imageIndex].name !== '' ? component.componentParams.images[imageIndex].name : imageIndex + 1;
        })),
        startRotation: Joi.string().error(errors => errorsHandler(errors, 'rotation_{INDEX_0}', 'Rotazione {NAME}', [1], (component, indexes) => {
          let imageIndex = indexes[0];
          return component.componentParams.images[imageIndex].name !== '' ? component.componentParams.images[imageIndex].name : imageIndex + 1;
        })),
        hideTitleOnThumbnail: Joi.boolean()
      }).required().error(errors => errorsHandler(errors, 'virtual_tours', 'Virtual Tours'))
    })
  }).options({
    stripUnknown: true
  });
};
export const VIRTUAL_TOUR_THUMB_CONFIG_VALIDATOR = () => {
  return Joi.object({
    componentParams: Joi.object({
      images: Joi.array().min(1).max(7).items({
        id: Joi.required(),
        img: Joi.string().required().error(errors => errorsHandler(errors, 'image_{INDEX_0}', 'Immagine {NAME}', [1], (component, indexes) => {
          let imageIndex = indexes[0];
          return component.componentParams.images[imageIndex].name !== '' ? component.componentParams.images[imageIndex].name : imageIndex + 1;
        })),
        name: Joi.string().required().error(errors => errorsHandler(errors, 'name_{INDEX_0}', 'Nome {NAME}', [1], (component, indexes) => {
          let imageIndex = indexes[0];
          return component.componentParams.images[imageIndex].name !== '' ? component.componentParams.images[imageIndex].name : imageIndex + 1;
        })),
        thumbnail: Joi.string().required().error(errors => errorsHandler(errors, 'thumbnail_{INDEX_0}', 'Immagine miniatura {NAME}', [1], (component, indexes) => {
          let imageIndex = indexes[0];
          return component.componentParams.images[imageIndex].name !== '' ? component.componentParams.images[imageIndex].name : imageIndex + 1;
        })),
        startRotation: Joi.string().error(errors => errorsHandler(errors, 'rotation_{INDEX_0}', 'Rotazione {NAME}', [1], (component, indexes) => {
          let imageIndex = indexes[0];
          return component.componentParams.images[imageIndex].name !== '' ? component.componentParams.images[imageIndex].name : imageIndex + 1;
        }))
      }).required().error(errors => errorsHandler(errors, 'virtual_tours', 'Virtual Tours'))
    })
  }).options({
    stripUnknown: true
  });
};
export const VIDEO_CONFIG_VALIDATOR = () => {
  return Joi.object({
    componentParams: Joi.alternatives().try(Joi.object().keys({
      url: Joi.string().allow(''),
      playerUrl: Joi.string().required()
    }), Joi.object().keys({
      url: Joi.string().required(),
      playerUrl: Joi.string().allow('')
    })).error(errors => errorsHandler(errors, 'video', 'Video'))
  }).options({
    stripUnknown: true
  });
};
export const COMPONENT_SWITCHER_CONFIG_VALIDATOR = () => {
  return Joi.object({
    componentParams: Joi.object({
      backgroundImage: Joi.string().required().error(errors => errorsHandler(errors, 'backgroundImage', 'Immagine di background')),
      components: Joi.array().min(1).max(4).items({
        thumbnail: Joi.string().required().error(errors => errorsHandler(errors, 'thumb_{INDEX_0}', 'Immagine box {NAME}', [1], (component, indexes) => {
          let index = indexes[0];
          return component.componentParams.components[index].title !== '' ? component.componentParams.components[index].title : index + 1;
        })),
        flagComingSoon: Joi.boolean().error(errors => errorsHandler(errors, 'coming_soon_{INDEX_0}', 'Coming soon box {NAME}', [1], (component, indexes) => {
          let index = indexes[0];
          return component.componentParams.components[index].title !== '' ? component.componentParams.components[index].title : index + 1;
        })),
        title: Joi.string().required().error(errors => errorsHandler(errors, 'title_{INDEX_0}', 'Titolo box {NAME}', [1], (component, indexes) => {
          let index = indexes[0];
          return component.componentParams.components[index].title !== '' ? component.componentParams.components[index].title : index + 1;
        }))
      }).required().error(errors => errorsHandler(errors, 'components', 'Box pagina di disambiguazione'))
    })
  }).options({
    stripUnknown: true
  });
};
export const INTERIOR_EXPERIENCE_SPLIT_CONFIG_VALIDATOR = () => {
  return Joi.object({
    componentParams: Joi.object({
      components: Joi.array().min(1).max(4).items({
        image: Joi.string().required().error(errors => errorsHandler(errors, 'image_{INDEX_0}', 'Immagine box {NAME}', [1], (component, indexes) => {
          let index = indexes[0];
          return component.componentParams.components[index].title !== '' ? component.componentParams.components[index].title : index + 1;
        })),
        flagComingSoon: Joi.boolean().error(errors => errorsHandler(errors, 'coming_soon_{INDEX_0}', 'Coming soon box {NAME}', [1], (component, indexes) => {
          let index = indexes[0];
          return component.componentParams.components[index].title !== '' ? component.componentParams.components[index].title : index + 1;
        })),
        title: Joi.string().required().error(errors => errorsHandler(errors, 'title_{INDEX_0}', 'Titolo box {NAME}', [1], (component, indexes) => {
          let index = indexes[0];
          return component.componentParams.components[index].title !== '' ? component.componentParams.components[index].title : index + 1;
        }))
      }).required().error(errors => errorsHandler(errors, 'components', 'Box pagina di disambiguazione'))
    })
  }).options({
    stripUnknown: true
  });
};
export const SERVIZI_CONFIG_VALIDATOR = () => {
  return Joi.object({
    componentParams: Joi.object({
      imageFolder: Joi.string(),
      backgroundImage: Joi.string().required().error(errors => errorsHandler(errors, 'background_image', 'Immagine di background')),
      serviziConfig: Joi.array().min(1).max(7).items({
        id: Joi.number().required(),
        name: Joi.string().required().error(errors => errorsHandler(errors, 'title_{INDEX_0}', 'Titolo servizio {NAME}', [1], (component, indexes) => {
          let index = indexes[0];
          return component.componentParams.serviziConfig[index].name !== '' ? component.componentParams.serviziConfig[index].name : index + 1;
        })),
        img: Joi.string().required().error(errors => errorsHandler(errors, 'img_{INDEX_0}', 'Immagine servizio {NAME}', [1], (component, indexes) => {
          let index = indexes[0];
          return component.componentParams.serviziConfig[index].name !== '' ? component.componentParams.serviziConfig[index].name : index + 1;
        }))
      }).required().error(errors => errorsHandler(errors, 'servizi', 'Servizi'))
    })
  }).options({
    stripUnknown: true
  });
};
const validatorMap = {
  HomePage: HOME_PAGE_CONFIG_VALIDATOR(),
  VirtualPhoto: VIRTUAL_PHOTO_CONFIG_VALIDATOR(),
  InteriorExperience: INTERIOR_EXPERIENCE_CONFIG_VALIDATOR(),
  SliderGallery: SLIDER_GALLERY_CONFIG_VALIDATOR(),
  SliderGalleryLogo: SLIDER_GALLERY_LOGO_CONFIG_VALIDATOR(),
  VirtualTour: VIRTUAL_TOUR_CONFIG_VALIDATOR(),
  VirtualTourThumb: VIRTUAL_TOUR_THUMB_CONFIG_VALIDATOR(),
  Video: VIDEO_CONFIG_VALIDATOR(),
  ComponentSwitcher: COMPONENT_SWITCHER_CONFIG_VALIDATOR(),
  InteriorExperienceSplit: INTERIOR_EXPERIENCE_SPLIT_CONFIG_VALIDATOR(),
  Servizi: SERVIZI_CONFIG_VALIDATOR()
};
export const getValidatorComponent = (currentComponent, currentPath) => {
  if (currentPath === '') {
    return validatorMap['HomePage'];
  }
  if (currentComponent.component === 'SliderGallery' && currentComponent.componentParams && currentComponent.componentParams.indexPosition === 'fullImage') {
    return validatorMap['SliderGalleryLogo'];
  }
  if (currentComponent.component === 'VirtualTour') {
    if (currentComponent.componentParams && currentComponent.componentParams.images && currentComponent.componentParams.images.length > 1) {
      return validatorMap['VirtualTourThumb'];
    }
    return validatorMap['VirtualTour'];
  }
  return validatorMap[currentComponent.component];
};